import './my-profile-lists.scss';
import {SquadflixCollection, SquadflixGetCollectionsResp} from "./types";
import {useEffect, useState} from "react";
import SquadflixCollectionCard from "../../../../shared/squadflix-collection-card/squadflix-collection-card";
import {Spinner} from "../../../../shared";
import SquadflixCollectionForm from "../../../../cap17drive/squadflix-collection-form/squadflix-collection-form";
import {useSelector} from "react-redux";
import users from "../../../../users";
import {cn} from "../../../../../utils/utils";
import {SquadflixCollectionsApi} from "../../../../../apis/squadflix-collections/SquadflixCollectionsApi";

const MyProfileLists = () => {
    const [collections, setCollections] = useState<SquadflixCollection[]>([]);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const darkMode = useSelector(users.selectors.isDarkMode);

    useEffect(() => {
        // Fetch user collections from API and set them
        SquadflixCollectionsApi.getMyCollections().then((res: SquadflixGetCollectionsResp) => {
            if (res.success) {
                setCollections(res.collections);
            }
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{height: '20vh'}}>
            <Spinner/>
        </div>
    }

    return <>
        <div className={cn("my-profile-lists", {"my-profile-lists--dark": darkMode})}>
            <button className="my-profile-lists-create-card" onClick={() => setOpenModal(true)}>
                <i className="my-profile-lists-create-card__icon fa-solid fa-plus fa-2x"></i>
                <span className="my-profile-lists-create-card__text">Crear colección</span>
            </button>
            {
                collections.map((collection, i) => (
                    <SquadflixCollectionCard key={collection.id + i.toString()} collection={collection}/>
                ))
            }
        </div>
        <SquadflixCollectionForm open={openModal} setOpen={setOpenModal} onCreate={(collection) => {
            setCollections([collection, ...collections]);
        }}/>
    </>;
}

export default MyProfileLists;
